/**
 * 游戏模块接口
 **/
import base from '../base'
import request from '../http'

export default {
  getPrizeList: promise => request('post', `${base.api.url}/api/v2/swiftspin/prize/list`, promise), // 奖品列表
  getActivityPrizeList: promise => request('post', `${base.api.url}/api/v2/swiftspin/admin/activity/config/list`, promise), // 奖品列表
  getAd: promise => request('post', `${base.api.url}/api/v2/swiftspin/ad`, promise), // 获取广告
  getWinnerList: promise => request('post', `${base.api.url}/api/v2/swiftspin/winner/top`, promise), // 获取获奖人员
  getCJConfig: promise => request('post', `${base.api.url}/api/v2/swiftspin/queryConfig`, promise), // 获取抽奖配置
  getPrizeRewardCode: (rewardCode, promise) => request('get', `${base.api.url}/api/v1/swiftspin/prize/${rewardCode}`, promise), // 抽奖
  getPrizeRedemption: (promise) => request('post', `${base.api.url}/api/v2/swiftspin/prize/redemption`, promise), // 抽奖
  getInfoCode: (rewardCode, promise) => request('get', `${base.api.url}/api/v1/swiftspin/info/${rewardCode}`, promise), // 判断是否中奖
  submitInfo: promise => request('post', `${base.api.url}/api/v1/swiftspin/submit/info`, promise), // 提交信息
  getPrizeListV2: promise => request('post', `${base.api.url}/api/v2/swiftspin/v2/prize/list`, promise) // 奖品列表
}
